type TransactionContact = {
  contact?: { name?: string | null } | null;
  rawContactName?: string | null;
};

export const getTransactionContactName = (
  transaction: TransactionContact
): string => transaction.contact?.name || transaction.rawContactName || '—';
